import { Elements } from "@stripe/react-stripe-js";
import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter, Route, Switch } from "#src/components/Router.tsx";
import ErrorBoundry from "#src/components/layout/ErrorBoundry.tsx";
import Layout from "#src/components/layout/Layout.tsx";
import Loading from "#src/components/layout/Loading.tsx";
import { queryClient } from "#src/stores/Api.tsx";
import { StoreProvider } from "#src/stores/Store.tsx";
import { stripe } from "#src/stores/Stripe.tsx";
import { CustomToaster } from "#src/utils/message.tsx";
import { ModalProvider } from "#src/utils/modals.ts";
import scriptLoader from "#src/utils/scriptLoader.ts";
import { Suspense, useEffect } from "react";
import { SessionProvider } from "./stores/Session";
import { UIProvider } from "./stores/UI";
import { stripeFonts } from "./utils/constants";
import lazyImport from "./utils/lazyImport";
import { ViewportProvider } from "./utils/useMediaQueries";
const Start = lazyImport(() => import("#src/routes/start/Start.tsx"));
// const MeetsEmbed = lazyImport(() => import("#src/routes/embed/MeetsEmbed.tsx"));

let testRoutes = [];

if (import.meta.env.DEV) {
  const EmailTest = lazyImport(
    () => import("#src/routes/superAdmin/EmailTest.tsx")
  );
  const MoveEmailTest = lazyImport(
    () => import("#src/routes/superAdmin/MoveEmailTest.tsx")
  );
  const CancelEmailTest = lazyImport(
    () => import("#src/routes/superAdmin/CancelEmailTest.tsx")
  );
  const PlainEmailTest = lazyImport(
    () => import("#src/routes/superAdmin/PlainEmailTest.tsx")
  );
  const InvoiceTest = lazyImport(
    () => import("#src/routes/superAdmin/InvoiceTest.tsx")
  );

  testRoutes = [
    <Route key="email" exact path="/email-test" component={EmailTest} />,
    <Route
      key="move-email"
      exact
      path="/move-email-test"
      component={MoveEmailTest}
    />,
    <Route
      key="cancel-email"
      exact
      path="/cancel-email-test"
      component={CancelEmailTest}
    />,
    <Route
      key="plain-email"
      exact
      path="/plain-email-test"
      component={PlainEmailTest}
    />,
    <Route key="invoice" exact path="/invoice-test" component={InvoiceTest} />,
  ];
}

export default function App() {
  // if (window.location.pathname.includes("/embed/")) {
  //   return (
  //     <ErrorBoundry>
  //       <QueryClientProvider client={queryClient}>
  //         <BrowserRouter>
  //           <React.Suspense
  //             fallback={<Loading delay={250} className="h-[75vh]" />}
  //           >
  //             <Switch>
  //               <Route path="/embed/meets" component={MeetsEmbed} />
  //             </Switch>
  //           </React.Suspense>
  //         </BrowserRouter>
  //       </QueryClientProvider>
  //     </ErrorBoundry>
  //   );
  // }

  useEffect(() => {
    const googleTagId = "UA-136870218-1";
    const googleTagUrl = `https://www.googletagmanager.com/gtag/js?id=${googleTagId}`;

    if (
      process.env.NODE_ENV !== "production" ||
      scriptLoader.has(googleTagUrl)
    ) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    function gtag(...args) {
      window.dataLayer.push(args);
    }

    gtag("js", new Date());
    gtag("config", googleTagId);

    const loadGoogleTag = () => {
      void scriptLoader.load(googleTagUrl);
    };

    if (typeof window.requestIdleCallback === "function") {
      const idleId = window.requestIdleCallback(loadGoogleTag);
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(loadGoogleTag, 1000);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <ErrorBoundry>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <StoreProvider>
            <Elements stripe={stripe} options={{ fonts: stripeFonts }}>
              <ViewportProvider>
                <SessionProvider>
                  <UIProvider>
                    <ModalProvider>
                      <Suspense
                        fallback={<Loading delay={250} className="h-[75vh]" />}
                      >
                        <Switch>
                          {testRoutes}
                          <Route path="/start" component={Start} />
                          <Route component={Layout} />
                        </Switch>
                      </Suspense>
                      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                      <CustomToaster />
                    </ModalProvider>
                  </UIProvider>
                </SessionProvider>
              </ViewportProvider>
            </Elements>
          </StoreProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundry>
  );
}
